module.exports = __webpack_public_path__ + "static/figure2-8894c47386ea939a061b680197938cf4.jpg";